import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExcelForm from "./BLBild";
import CityDefinitionForm from "./DefinitionOfResidency";
import CenteredImage from "../plagins/workerPage";
import { GlobalContext } from "../../../App";
import { generateExcelTemplate } from "./generateExcelTemplate";
import DynamicFormHerp from "./DynamicForm";

const GeneralSettings = ({ title, description }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        textAlign: "center",
      }}
    >
      <CenteredImage />
    </Box>
  );
};

const generateExcel = ({ title, description }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        textAlign: "center",
      }}
    >
            <Typography variant="h4">{title}</Typography>
      <Typography variant="body1">{description}</Typography>
      <Button onClick={generateExcelTemplate}>להורדת תבנית אקסל לדיווח ביטוח לאומי</Button>
    </Box>
  );
};


const PersonalSettings = ({ title, description }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        textAlign: "center",
      }}
    >
      <CenteredImage />
    </Box>
  );
};

const ResidencySettings = ({ title, description }) => {
  return (
    <Box
      sx={{
        // display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        textAlign: "center",
      }}
    >
      <CityDefinitionForm />
    </Box>
  );
};

const BTL_Files = ({ title, description }) => {
  return (
    <Box
      sx={{
        // display: "flex",
        // flexDirection: "column",
        // justifyContent: "center",
        // alignItems: "center",
        // height: "100%",
        // textAlign: "center",
      }}
    >
      {/* <Typography variant="h4">{title}</Typography> */}
      {/* <Typography variant="body1">{description}</Typography> */}
      <ExcelForm />
    </Box>
  );
};
const generateDynamicForm = ({ title, description }) => {
  return (
    <Box
      sx={{
        // display: "flex",
        // flexDirection: "column",
        // justifyContent: "center",
        // alignItems: "center",
        // height: "100%",
        // textAlign: "center",
      }}
    >
      {/* <Typography variant="h4">{title}</Typography> */}
      {/* <Typography variant="body1">{description}</Typography> */}
      <DynamicFormHerp />
    </Box>
  );
};



const menuData = [
  {
    label: "הגדרות כלליות",
    tabs: [
      {
        label: "טאב 1",
        component: GeneralSettings,
        props: { title: "טאב 1 - הגדרות כלליות", description: "תוכן טאב 1" },
      },
      {
        label: "טאב 2",
        component: GeneralSettings,
        props: { title: "טאב 2 - הגדרות כלליות", description: "תוכן טאב 2" },
      },
    ],
  },
  {
    label: "הגדרות אישיות",
    tabs: [
      {
        label: "טאב 1",
        component: PersonalSettings,
        props: { title: "טאב 1 - הגדרות אישיות", description: "תוכן טאב 1" },
      },
      {
        label: "טאב 2",
        component: PersonalSettings,
        props: { title: "טאב 2 - הגדרות אישיות", description: "תוכן טאב 2" },
      },
    ],
  },
  {
    label: "הגדרת תושבות",
    tabs: [
      {
        label: "הגדרת תושבות מוניציפלית",
        component: ResidencySettings,
        props: { title: "טאב 1 - הגדרת תושבות", description: "תוכן טאב 1" },
      },
      // {
      //   label: "טאב 2",
      //   component: BTL_Files,
      //   props: { title: "טאב 2 - הגדרת תושבות", description: "תוכן טאב 2" },
      // },
    ],
  },
  {
    label: "הגדרות זמניות",
    tabs: [
      {
        label: "דיווח ביטוח לאומי בקובץ",
        component: BTL_Files,
        props: { title: "טאב 1 - הגדרת תושבות", description: "תוכן טאב 1" },
      },
      {
        label: "תבנית אקסל ביטוח לאומי",
        component: generateExcel,
        props: { title: "הורדת תבנית אקסל לביטוח לאומי", description: "" },
      },
      {
        label: "תבנית דיווח לחשבשבת",
        component: generateDynamicForm,
        props: { title: "תבנית דיווח לחשבשבת", description: "" },
      },
    ],
  },
];

const ResponsiveBoxWithSidebar = () => {
  const { setTitle } = useContext(GlobalContext);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentMenu, setCurrentMenu] = useState(0);
  const [currentTab, setCurrentTab] = useState(0);

  const isTabletOrDesktop = useMediaQuery("(min-width:768px)");

    useEffect(() => {
        setTitle(`הגדרות`);
    }, []);

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  const handleMenuClick = (menuIndex) => {
    setCurrentMenu(menuIndex);
    setCurrentTab(0); // Reset to the first tab when switching menus
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "95%", md: "80%" },
        height: { xs: "100vh", sm: "95vh", md: "80vh" },
        display: "flex",
        bgcolor: "white",
        boxShadow: 3,
        borderRadius: 2,
        position: "relative", // Ensures child components are contained
        overflow: "hidden",
      }}
    >
      {/* Sidebar */}
      <Drawer
        variant={isTabletOrDesktop ? "permanent" : "temporary"}
        open={isTabletOrDesktop || isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        ModalProps={{
          keepMounted: true,
        }}
        container={() => document.getElementById("unique-drawer-container")}
        sx={{
          width: 200,
          flexShrink: 0,
          height: "100%", // Ensures the sidebar takes full height
          position: "absolute",
          zIndex: 1200,
          "& .MuiDrawer-paper": {
            width: 200,
            height: "100%",
            backgroundColor: "#f9f9f9", // Light background for Material UI style
            color: "#333", // Darker text for contrast
            transition: "width 0.3s",
            overflowX: "hidden",
            position: "absolute",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <Toolbar />
        <List>
          {menuData.map((item, index) => (
            <ListItem
              button
              key={index}
              onClick={() => handleMenuClick(index)}
              sx={{
                "&:hover": {
                  backgroundColor: "#e0e0e0", // Subtle hover effect
                },
              }}
            >
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* Main Content */}
      <Box
        id="unique-drawer-container"
        sx={{
          flex: 1,
          p: 2,
          overflow: "auto", // Scroll for content
          height: "100%", // Ensure content box always fills parent height
          marginLeft: isTabletOrDesktop ? "200px" : 0, // Offset for permanent drawer
          position: "relative",
        }}
      >
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          {menuData[currentMenu].tabs.map((tab, index) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
        <Box sx={{ p: 2, height: "100%" }}>
          {React.createElement(
            menuData[currentMenu].tabs[currentTab].component,
            menuData[currentMenu].tabs[currentTab].props
          )}
        </Box>
      </Box>

      {/* Hamburger Menu */}
      {!isTabletOrDesktop && (
        <IconButton
          onClick={toggleDrawer}
          sx={{
            position: "absolute",
            top: 16,
            left: 16,
            zIndex: 1300,
          }}
        >
          <MenuIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default ResponsiveBoxWithSidebar;
